import'./creator-screen.scss'

/**
 *  Component Definition
 *
 * @export
 * @class CreatorScreen
 * @implements {ng.IComponentOptions}
 */
export class CreatorScreen implements ng.IComponentOptions {

  /**
   * Controller used with Component
   *
   * @type {Function}
   */
  public controller: Function = CreatorScreenController

  /**
   * Template used with Component
   *
   * @type {string}
   */
  public template: string = require('./creator-screen.html').toString()

  /**
   * Object containing pairs Directive Bindings for Component
   *
   * @type {Object}
   */
  public bindings: { [binding: string]: string; } = {
    options: '=',
    isLast: '@',
    isFirst: '@',
  }
}

/**
 * CreatorScreen - Controller
 *
 * @export
 * @class CreatorScreenController
 */
export class CreatorScreenController {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', 'AngularServices', 'AppServices', '$element', '$animate', 'AudioManager', '$rootScope', 'ProgressManager', 'TrackingManager']
  public options
  public isLast
  public isFirst
  public bpCarousel
  public bpSlides
  public bpButtonNext
  public bpButtonPrev
  public currentSlide
  public maxSlides = this.AppServices.DataManager.config.settings.costumes;

  /**
   * @param {*} $log Angular Log Service
   * @param {*} AngularServices Angular Services Convenience Service
   * @param {*} AppServices App Services Convenience Service
   */
  constructor(public $log: any, public AngularServices: any, public AppServices: any, public $element: any, public $animate: any, public AudioManager: any, public $rootScope: any, public ProgressManager: any, public TrackingManager: any) {
    this.$log = $log.getInstance('CreatorScreen', false);
    this.$log.debug('constructor')

    this.$rootScope.$on('bodypartClicked', (event, data) => {
      this.setBP(data.bp)
    })
  }

  public onNext() {
    // this.AppServices.HeroManager.setHeroImageData()
    this.AppServices.HeroManager.zoomOut()
    this.AppServices.ScreenManager.performNavigation('next', this.options)
  }

  public onPrevious() {
    // this.AppServices.HeroManager.setHeroImageData()
    this.AppServices.HeroManager.zoomOut()
    this.AppServices.ScreenManager.performNavigation('previous', this.options)
  }

  public onEnterStart() {
    this.$log.debug('onEnterStart');
    this.$animate.removeClass(document.getElementsByTagName('hero-image')[0], 'leave');
    this.$animate.removeClass(document.getElementById('podium-container'), 'leave');
    document.getElementById('podium-container').style.display = 'block';
    this.AngularServices.$timeout(() => {
      this.AudioManager.playFx('podium')
    }, 750);
  }
  public onEnterComplete() {
    this.$log.debug('onEnterComplete');
  }

  public onExitStart() {
    this.$log.debug("onExitStart")
    this.options.navReady = false
    // this.AngularServices.$animate.removeClass(angular.element(document.querySelector('.landing-screen__start')), 'flipInX');
    // this.AngularServices.$animate.addClass(angular.element(document.querySelector('.landing-screen__start')), 'flipOutX');
  }

  public onExitComplete() {
    this.$log.debug("onExitComplete")
    document.getElementById('podium-container').style.display = 'none';
  }

  /**
   * life cycle hooks (road to ng2)
   * Called on each controller after all the controllers on an element have been constructed and had their bindings initialized (and before the pre & post linking functions for the directives on this element).
   */
  public $onInit(): void {
    this.$log.debug('onInit')
    this.options.isLast = this.isLast;
    this.options.isFirst = this.isFirst;
    this.options.$element = this.$element;
    this.options.$ctrl = this;
    this.AppServices.ScreenManager.creatorScreenOptions = this.options
    document.getElementById('podium-container').style.display = 'block';
    this.bpCarousel = document.getElementById('body-part-slides');
    this.bpSlides = this.bpCarousel.getElementsByClassName('slide');
    this.bpButtonNext = document.getElementById('bodypart-next-button');
    this.bpButtonPrev = document.getElementById('bodypart-prev-button');
    angular.element(this.AngularServices.$window).bind('orientationchange', this.bpCarouselSize);
  }

  public setBP(bp): void{
    let gender = this.AppServices.HeroManager.selectedGender
    this.options.carousel = this.AppServices.CarouselManager.add(this.AppServices.DataManager.config.carousels.filter((value, index, array) => { return value.key === 'bodyParts-' + bp + '-' + gender })[0])
    if (this.AppServices.DataManager.config.settings.costumes === 3){
      this.options.carousel.items.splice (-1 , 2)
      this.maxSlides = 3
    }
    let bpClass = $('#' + bp).attr('class').split(' ')
    for (let i in this.options.carousel.items){
      if (this.options.carousel.items[i].costumeName === bpClass[0]){
        this.currentSlide = i
        this.bpGoToSlide(this.currentSlide);
      }
    }
  }

  public highlightBodyPart(bp): void{
    this.$animate.addClass(document.querySelector('#'+bp), 'highlight-body-part');
  }

  public stopHighlightBodyPart(bp): void{
    this.$animate.removeClass(document.querySelector('#'+bp), 'highlight-body-part');
  }

  public changeToggle(tool, sendReport:boolean = true): void {

      if (tool === 'bucket') {
        this.AppServices.HeroManager.useBucket = true;
        this.AppServices.HeroManager.useEyedropper = false;
        this.AppServices.HeroManager.activeTool = 'bucket'
        this.$animate.addClass(document.querySelector('.creator-screen.active'), 'paintbucket')
        this.$animate.removeClass(document.querySelector('.creator-screen.active'), 'paintbrush')
        this.$animate.removeClass(document.querySelector('.creator-screen.active'), 'eyedropper')
      } else if (tool === 'brush') {
        this.AppServices.HeroManager.useBucket = false;
        this.AppServices.HeroManager.useEyedropper = false;
        this.AppServices.HeroManager.activeTool = 'brush'
        this.$animate.addClass(document.querySelector('.creator-screen.active'), 'paintbrush')
        this.$animate.removeClass(document.querySelector('.creator-screen.active'), 'paintbucket')
        this.$animate.removeClass(document.querySelector('.creator-screen.active'), 'eyedropper')
      } else if(tool === 'eyedropper'){
        this.AppServices.HeroManager.useEyedropper = true;
        this.AppServices.HeroManager.useBucket = false;
        this.AppServices.HeroManager.activeTool = 'eyedropper'
        this.$animate.addClass(document.querySelector('.creator-screen.active'), 'eyedropper')
        this.$animate.removeClass(document.querySelector('.creator-screen.active'), 'paintbrush')
        this.$animate.removeClass(document.querySelector('.creator-screen.active'), 'paintbucket')
      }

      if (sendReport) {
        this.TrackingManager.trackTool(this.AppServices.HeroManager.activeTool)
      }

  }

 public bpNextSlide () {
    this.currentSlide = (this.currentSlide+1 + this.maxSlides) % this.maxSlides;
    this.bpCarouselSize();
  }

  public bpPrevSlide(){
    this.currentSlide = (this.currentSlide-1 + this.maxSlides) % this.maxSlides;
    this.bpCarouselSize();
  }

  public bpGoToSlide(n){
    this.currentSlide = n % this.maxSlides;
    this.bpCarouselSize();
  }

  public bpCarouselSize(){
    let bpCarouselWidth = document.querySelector('.creator-screen__sidebar__contents').clientWidth;
    //will need to add more cases here when we get more poses
    if (this.AppServices.DataManager.config.settings.costumes === 5){
      switch (this.currentSlide) {
        case 0:
          this.bpCarousel.style.left = (bpCarouselWidth) / 4.51515  + 'px'
          break;
        case 1:
          this.bpCarousel.style.left = -(bpCarouselWidth) / 3.5476 + 'px'
          break;
        case 2:
          this.bpCarousel.style.left = -(bpCarouselWidth) / 1.27350 + 'px'
          break;
        case 3:
          this.bpCarousel.style.left = -(bpCarouselWidth) * 1.28859   + 'px'
          break;
        case 4:
          this.bpCarousel.style.left = -(bpCarouselWidth) * 1.79193  + 'px'
          break;
        default: break;
      }
    }else {
      switch (this.currentSlide) {
        case 0:
          this.bpCarousel.style.left = (bpCarouselWidth) / 4.51515  + 'px'
          break;
        case 1:
          this.bpCarousel.style.left = -(bpCarouselWidth) / 3.5476 + 'px'
          break;
        case 2:
          this.bpCarousel.style.left = -(bpCarouselWidth) / 1.27350 + 'px'
          break;
        default: break;
      }
    }

    // carousel.style.left = - currentSlide * (w/slides.length)+ 'px';
    this.bpCarousel.style.width = bpCarouselWidth * (this.maxSlides/2) + 'px';
    for(let i=0; i < this.bpSlides.length; i++){
      this.bpSlides[i].style.width = bpCarouselWidth * (this.maxSlides/2) / this.maxSlides + 'px';
    }
  }

  /**
   * Randomize function loops through all bodyparts and sets a random costume piece for that bodypart
   */


  /**
   * Called whenever one-way bindings are updated.
   * The changesObj is a hash whose keys are the names of the bound properties that have changed, and the values are an object of the form { currentValue, previousValue, isFirstChange() }.
   * Use this hook to trigger updates within a component such as cloning the bound value to prevent accidental mutation of the outer value.
   */
  public $onChanges(changesObj): void {
    this.$log.debug('onChanges', changesObj)
  }

  /**
   * Called on a controller when its containing scope is destroyed.
   * Use this hook for releasing external resources, watches and event handlers.
   */
  public $onDestroy(): void {
    this.$log.debug('onDestroy')
  }

  /**
   * Called after this controller's element and its children have been linked.
   * Similar to the post-link function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
   * Note that child elements that contain templateUrl directives will not have been compiled and linked since they are waiting for their template to load asynchronously and their own compilation and linking has been suspended until that occurs.
   * This hook can be considered analogous to the ngAfterViewInit and ngAfterContentInit hooks in Angular 2.
   * Since the compilation process is rather different in Angular 1 there is no direct mapping and care should be taken when upgrading.
   */
  public $postLink(): void {
    this.$log.debug('postLink')
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/creator-screen/creator-screen.ts
 **/